/**
 * @generated SignedSource<<1d36b5e71554110619d0253f4d73a758>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SageSyncAnalysisPage_Query$variables = {
  companyId?: number | null;
  analysisId?: number | null;
  forceRefresh?: boolean | null;
};
export type SageSyncAnalysisPage_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SageSyncAnalysisPage_viewer">;
  } | null;
};
export type SageSyncAnalysisPage_Query = {
  variables: SageSyncAnalysisPage_Query$variables;
  response: SageSyncAnalysisPage_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "analysisId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "companyId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "forceRefresh"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "sage_sync_analysis"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"sage_sync_analysis\")"
},
v5 = {
  "kind": "Variable",
  "name": "companyId",
  "variableName": "companyId"
},
v6 = [
  {
    "kind": "Variable",
    "name": "analysisId",
    "variableName": "analysisId"
  },
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "forceRefresh",
    "variableName": "forceRefresh"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SageSyncAnalysisPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v6/*: any*/),
            "kind": "FragmentSpread",
            "name": "SageSyncAnalysisPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "SageSyncAnalysisPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MissionControlDataType",
            "kind": "LinkedField",
            "name": "missionControlData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "MissionControlSageSyncAnalysisType",
                "kind": "LinkedField",
                "name": "companySyncAnalysis",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "companyName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v5/*: any*/)
                ],
                "concreteType": "MissionControlSageSyncAnalysisHistoryType",
                "kind": "LinkedField",
                "name": "companySyncAnalysisHistory",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCompanyId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "syncDate",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9c1f04a6c9e2dc40b9390abb50c57a0d",
    "id": null,
    "metadata": {},
    "name": "SageSyncAnalysisPage_Query",
    "operationKind": "query",
    "text": "query SageSyncAnalysisPage_Query(\n  $companyId: Int\n  $analysisId: Int\n  $forceRefresh: Boolean\n) {\n  viewer {\n    actualPersonId\n    component(name: \"sage_sync_analysis\")\n    ...SageSyncAnalysisPage_viewer_2oK7PD\n    id\n  }\n}\n\nfragment MissionControlHeader_viewer on Viewer {\n  email\n  actualPersonId\n  firstName\n  lastName\n  company {\n    id\n    name\n  }\n}\n\nfragment SageSyncAnalysisPage_viewer_2oK7PD on Viewer {\n  id\n  ...MissionControlHeader_viewer\n  missionControlData {\n    companySyncAnalysis(companyId: $companyId, analysisId: $analysisId, forceRefresh: $forceRefresh) {\n      id\n      companyId\n      companyName\n    }\n    companySyncAnalysisHistory(companyId: $companyId) {\n      id\n      forecastCompanyId\n      syncDate\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "604a75d2be5e0435cb9240c30180cb6a";

export default node;
